import { Booking } from "../booking/types"

export type TimeSlot = {
    date: string,
    timeslot: number,
}

export enum BookingMode {
    FIXED_SLOTS = 'fixed_slots',
    CUSTOM_PERIODS = 'custom_periods',
}

export type Availability = {
    start_date: string,
    end_date: string,
    booking_mode?: BookingMode,
    days: {
        pickup: TimeSlot,
        dropoff: TimeSlot,
    }[],
}

export type Bike = {
    id: number,
    bicycle_code: string,
    brand: string,
    type: string,
    frame_type?: string,
    model?: string,
    lease_price?: {
        [key: string]: string
    },
    range?: number,
    // Locale specific (returns a list of translations)
    description?: {
        [key: string]: string
    }
    propulsion: string,
    image_url?: string,
    starter_guide_url?: string,
    availabilities: Availability,
    location?: string,
    bookings?: Booking[],
    deployment_bicycle_id?: number,
    inactive?: boolean,
}
